import styled from "styled-components";

export const PageHeaderShadow = styled.div`
    position: fixed;

    top: 0;
    padding: 0;

    width: 100%;
    height: 3.6rem;

    box-shadow: 0 5px 10px 0 var(--color-header-shadow);

    z-index: 0;
`;
